import React from 'react';

const WorkSteps = ({ onOpenApplicationModal }) => {
    const steps = [
        {
            id: 1,
            title: 'Поиск авто по параметрам',
            description: 'Предлагаем варианты автомобилей максимально соответствующие запросам/требованиям (комплектация, технические характеристики и пожелания клиента) или выбираете с каталога самостоятельно',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                    <path d="M8 11a3 3 0 1 0 6 0"></path>
                </svg>
            )
        },
        {
            id: 2,
            title: 'Официальный договор',
            description: 'Подписываем официальный договор с указанием всех сроков.',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10,9 9,9 8,9"></polyline>
                </svg>
            )
        },
        {
            id: 3,
            title: 'Таможенное оформление',
            description: 'Оформлением занимается брокер, сроки: 1-3дня',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8a3 3 0 0 0-5.4 0"></path>
                    <path d="M16.5 12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"></path>
                    <path d="M3 21l6-6"></path>
                </svg>
            )
        },
        {
            id: 4,
            title: 'Настраиваем логистику',
            description: 'Процесс занимает до 2-х дней.',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="3" width="15" height="13"></rect>
                    <polygon points="16,8 20,8 23,11 23,16 16,16"></polygon>
                    <circle cx="5.5" cy="18.5" r="2.5"></circle>
                    <circle cx="18.5" cy="18.5" r="2.5"></circle>
                </svg>
            )
        },
        {
            id: 5,
            title: 'Передача новому владельцу',
            description: 'Подписываете акт приема-передачи автомобиля',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
                </svg>
            )
        },
        {
            id: 6,
            title: 'Проверка авто',
            description: 'Проверяете автомобиль на любом сервисе или с подборщиком',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"></path>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                </svg>
            )
        },
        {
            id: 7,
            title: 'Оформление в ГИБДД',
            description: 'С автомобилем приедет наш человек, который поможет полностью оформить автомобиль, получить номерные знаки в ГАИ.',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <circle cx="12" cy="16" r="1"></circle>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
            )
        },
        {
            id: 8,
            title: 'Жмем руки',
            description: 'Вы наслаждаетесь собственным автомобилем и рекомендуете нас вашим знакомым!',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M8 21l4-7 4 7"></path>
                    <path d="M12 21v-7"></path>
                    <path d="M22 12h-4l-3 7-3-7-3 7-3-7H2"></path>
                    <path d="M2 12l10-10 10 10"></path>
                </svg>
            )
        }
    ];    return (
        <div className="work-steps-section-redesigned">
            <div className="work-steps-container-redesigned">
                <div className="work-steps-header-redesigned">
                    <h2 className="work-steps-title-redesigned">Этапы работы с нами</h2>
                    <div className="work-steps-subtitle-redesigned">
                        Подробный план нашей работы от поиска до получения автомобиля
                    </div>
                </div>

                <div className="work-steps-grid-redesigned">
                    {steps.map((step, index) => (
                        <div key={step.id} className="work-step-card-redesigned">
                            <div className="step-number-redesigned">
                                {step.id}
                            </div>
                            <div className="step-icon-redesigned">
                                {step.icon}
                            </div>
                            <div className="step-content-redesigned">
                                <h3 className="step-title-redesigned">{step.title}</h3>
                                <p className="step-description-redesigned">{step.description}</p>
                            </div>
                            {index < steps.length - 1 && (
                                <div className="step-connector-redesigned">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="9,18 15,12 9,6"></polyline>
                                    </svg>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="work-steps-cta-redesigned">
                    <button
                        className="work-steps-button-redesigned"
                        onClick={onOpenApplicationModal}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                        </svg>
                        Начать работу с нами
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WorkSteps;